import React from 'react';
import {Button} from "antd";
import classes from "./buttons.module.css";

const BlackerBlueButton = (props) => {
    return (
        <Button {...props} className={classes.blackerBlueButton}>
            <span>{props.children}</span>
        </Button>
    );
};

BlackerBlueButton.propTypes = {
    ...Button.propTypes, // Use Ant Design Button propTypes
};

export default BlackerBlueButton;